import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const api = axios.create({ baseURL: API, withCredentials: true });

// attach bearer as fallback for environments where 3rd-party cookies are blocked
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("drivons_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const LOCALE_BY_LANG = { en: "en-US", tr: "tr-TR", he: "he-IL", ar: "ar-AE" };

// Currency formatting is fully data-driven + locale-aware. The currency ALWAYS comes from
// the store/order/country data; the fallback only prevents a crash if data is missing.
export function money(amount, currency, locale) {
  const cur = currency || localStorage.getItem("drivons_currency") || "USD";
  const loc = locale || LOCALE_BY_LANG[localStorage.getItem("drivons_lang")] || "en-US";
  try {
    return new Intl.NumberFormat(loc, { style: "currency", currency: cur, maximumFractionDigits: 2 }).format(amount || 0);
  } catch {
    return `${cur} ${(amount || 0).toFixed(2)}`;
  }
}

export default api;
